function Welcome() {

    this.$welcome = document.querySelector('.js-welcome');

    // The duration that the welcome screen should be visible for
    this.viewingDuration = 3000;
    // The duration that the welcome screen fades out for
    this.fadeDuration = 300;

    // Get ready for the time-based or click-based closure of the welcome screen
    this.init = function() {
        if (this.$welcome != null) {
            this.timeout = setTimeout(this.deactivate.bind(this), this.viewingDuration);
            this.$welcome.onclick = this.deactivate.bind(this);
        }
    }

    // Deactivate the welcome screen
    this.deactivate = function() {
        this.fade();
        setTimeout(this.remove.bind(this), this.fadeDuration);
        clearTimeout(this.timeout);
    }

    // Fade out the welcome screen
    this.fade = function() {
        this.$welcome.classList.remove('welcome--active');
    }

    // Remove the welcome screen
    this.remove = function() {
        this.$welcome.parentNode.removeChild(this.$welcome);
    }
}
